import * as React from "react"
import { Link } from "gatsby"

import Container from "../container/container"

import * as styles from "../cta/cta.module.scss"

const CtaSection = props => {
  return (
    <div
      className={styles.cta}
      style={{
        backgroundImage: `url(${props.data.BackgroundImage.publicURL})`,
      }}
    >
      <Container>
        <div
          className={`d-flex align-items-center justify-content-between ${styles.cta__wrap}`}
        >
          <p>{props.data.Text}</p>
          <Link to={props.data.ButtonLink}>{props.data.ButtonText}</Link>
        </div>
      </Container>
    </div>
  )
}

export default CtaSection
